import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withModifiers as _withModifiers, vShow as _vShow, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2bbf0f3a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { "data-testid": "edit-work" }
const _hoisted_2 = { class: "row no-space edit-work-form-wrapper" }
const _hoisted_3 = { class: "col-12" }
const _hoisted_4 = { class: "row no-space" }
const _hoisted_5 = { class: "col-10" }
const _hoisted_6 = ["data-testid"]
const _hoisted_7 = {
  key: 0,
  class: "col-12"
}
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col-10" }
const _hoisted_10 = { class: "row no-space justify-between" }
const _hoisted_11 = ["disabled"]
const _hoisted_12 = {
  class: "col-12",
  "data-testid": "edit-work-loader"
}

import { ErrorMessage, useForm } from 'vee-validate'
import { computed, ref, toRefs } from 'vue'
import { useGettext } from 'vue3-gettext'
import { useUserStore } from '@/store/user'
import { useWorksStore } from '@/store/works'
import {
  emptyAlternativeTitle,
  emptySample,
} from '@/constants'
import { getErrorMessage, getErrorTitle } from '@/helpers/errors'
import { isApiErrorResponse, formatWorksApiErrors } from '@/helpers/api'
import LoaderUI from '@/components/CommonUI/LoaderUI.vue'
import IconUI from '@/components/CommonUI/IconUI.vue'
import NotificationUI from '@/components/CommonUI/NotificationUI.vue'
import UserDetailsConfirmationDialog from '@/components/AddWork/UserDetailsConfirmationDialog.vue'
import WorkWriters from '@/components/AddWork/WorkWriters.vue'
import AlternativeTitles from '@/components/AddWork/AlternativeTitles.vue'
import WorkSamples from '@/components/AddWork/WorkSamples.vue'
import UpgradeDialog from '@/components/UpgradeDialog.vue'
import workSchema from '@/components/ValidationSchemas/work'

interface Props {
  work: Work
}


export default /*#__PURE__*/_defineComponent({
  __name: 'EditWork',
  props: {
    work: {}
  },
  emits: ["cancel"],
  setup(__props: any, { emit }) {

const props = __props;

const { $gettext } = useGettext()

const { work } = toRefs(props)

const workStore = useWorksStore()
const userStore = useUserStore()
const isEditWorkLoading = ref(false)
const noSubscriptionDialog = ref<InstanceType<typeof UpgradeDialog> | null>(null)
const userDetailsConfirmationDialog = ref<InstanceType<typeof UserDetailsConfirmationDialog> | null>(null)

const track = computed(() => work.value.track)

function getInitialValues(): WorkForm {
  const workForm: WorkForm = {
    ...structuredClone(work.value),
    hasSamples: !!work.value.samples.length,
  }

  workForm.alternative_titles.length || workForm.alternative_titles.push(structuredClone(emptyAlternativeTitle))
  workForm.samples.length || workForm.samples.push(structuredClone(emptySample))

  return workForm
}

const { errors, handleSubmit, setErrors, values, setValues } = useForm({
  validationSchema: workSchema(track.value?.title),
  initialValues: getInitialValues(),
})

const isSubmitDisabled = computed(() => !!Object.keys(errors.value).length)

async function editWork(work: WorkForm) {
  isEditWorkLoading.value = true

  try {
    await workStore.editWork(work)

    setValues(getInitialValues())
  } catch (error) {
    if (isApiErrorResponse(error)) {
      const errors = formatWorksApiErrors(error as ApiResponseError)

      setErrors(errors)

      if (errors.missing_subscription) {
        noSubscriptionDialog.value?.show()
      }
    }
  }

  isEditWorkLoading.value = false
}

const onSubmit = handleSubmit((work: WorkForm) => {
  const isWriterCurrentUser = work.writers
    .some(writer => writer.email.trim().toLowerCase() === userStore.userDetails?.emailAddress.trim().toLowerCase())
  if (isWriterCurrentUser && userStore.userDetails?.isReviewDetailsDisplayable) {
    userDetailsConfirmationDialog.value?.show()
    return
  }
  editWork(work)
})

async function deleteWork(workId: number) {
  isEditWorkLoading.value = true

  try {
    await workStore.deleteWork(workId)
  } catch (error) {
    const errorMessage = getErrorTitle(error)
      ? `${getErrorTitle(error)} - ${getErrorMessage(error)}`
      : getErrorMessage(error)

    setErrors({
      0: [errorMessage],
    } as ApiErrors)
  }

  isEditWorkLoading.value = false
}

return (_ctx: any,_cache: any) => {
  const _directive_translate = _resolveDirective("translate")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(UpgradeDialog, {
      ref_key: "noSubscriptionDialog",
      ref: noSubscriptionDialog,
      "data-testid": "noSubscriptionDialog",
      dismissible: ""
    }, null, 512),
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("div", _hoisted_3, [
        _createElementVNode("form", {
          onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_unref(onSubmit) && _unref(onSubmit)(...args)), ["prevent"]))
        }, [
          _createVNode(_unref(ErrorMessage), { name: "0" }, {
            default: _withCtx(({ message }) => [
              _createVNode(NotificationUI, {
                message: message,
                type: "error outline",
                "icon-fill": "error",
                "icon-name": "danger"
              }, null, 8, ["message"])
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(AlternativeTitles)
            ])
          ]),
          _createElementVNode("div", {
            class: "row no-space",
            "data-testid": `work-writers${_unref(work).id}`
          }, [
            (track.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createVNode(WorkWriters, {
                    track: track.value,
                    "work-id": _unref(work).id
                  }, null, 8, ["track", "work-id"])
                ]))
              : _createCommentVNode("", true)
          ], 8, _hoisted_6),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createVNode(WorkSamples)
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("button", {
              class: "button tertiary button-small delete-work-button",
              type: "button",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (deleteWork(Number(_unref(work).id))))
            }, [
              _createVNode(IconUI, { name: "rubbish-bin" }),
              _createTextVNode(" " + _toDisplayString(_unref($gettext)('Delete work')), 1)
            ]),
            _createElementVNode("div", null, [
              _withDirectives((_openBlock(), _createElementBlock("button", {
                class: "button black cancel-button",
                type: "button",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('cancel')))
              }, [
                _createTextVNode(" Cancel ")
              ])), [
                [_directive_translate]
              ]),
              _withDirectives((_openBlock(), _createElementBlock("button", {
                class: "button",
                type: "button",
                disabled: isSubmitDisabled.value,
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_unref(onSubmit) && _unref(onSubmit)(...args)))
              }, [
                _createTextVNode(" Save edits ")
              ], 8, _hoisted_11)), [
                [_directive_translate]
              ])
            ])
          ])
        ], 32)
      ], 512), [
        [_vShow, !isEditWorkLoading.value]
      ]),
      _createVNode(UserDetailsConfirmationDialog, {
        ref_key: "userDetailsConfirmationDialog",
        ref: userDetailsConfirmationDialog,
        onSave: _cache[4] || (_cache[4] = ($event: any) => (editWork(_unref(values))))
      }, null, 512),
      _withDirectives(_createElementVNode("div", _hoisted_12, [
        _createVNode(LoaderUI, { "ditto-plus": "" })
      ], 512), [
        [_vShow, isEditWorkLoading.value]
      ])
    ])
  ]))
}
}

})